import { render } from "./FormName.vue?vue&type=template&id=4c286bf8&ts=true"
import script from "./FormName.vue?vue&type=script&lang=ts"
export * from "./FormName.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__